module.exports = __webpack_public_path__ + "static/media/Trio Evocacion 2.15817bcb.jpg";